import { useBookingContext } from '../context';
import { useState } from 'react';
import InputMask from 'react-input-mask';
import { v4 as uuidv4 } from 'uuid';
import { BASE_URL } from '../api';

export default () => {
  const {
    selectedDate,
    isPhoneModalOpen,
    setIsOpenModal,
    clearState,
    startTime,
    endTime,
    court,
    price
  } = useBookingContext();

  const [phoneNumber, setPhoneNumber] = useState('');
  const [name, setName] = useState('');
  const [orderId] = useState(uuidv4());

  const clearAllState = () => {
    setPhoneNumber('');
    clearState();
  };

  const disabledPayment = phoneNumber.length !== 12;

  const bookingData = JSON.stringify({
    startTime,
    endTime,
    courtId: court?.courtId,
    price: price,
    date: selectedDate.format('DD-MM-YYYY'),
    phoneNumber: `${phoneNumber}`,
    orderId: orderId,
    name: name
  });

  return (
    <div className={`modal ${isPhoneModalOpen && 'open'}`}>
      <article className="content-wrapper mx-0 sm:mx-10 w-full md:w-[60%] md:mx-0 lg:w-[40%]">
        <button
          className="close close__button"
          onClick={() => {
            setIsOpenModal(false);
            clearAllState();
          }}></button>
        <header className="modal-header">
          <h2>Деталі бронювання</h2>
        </header>

        <div id="form" className="modal__body">
          <div className="content modal__content">
            <div className="modal__content-block">
              <div className="modal__content-icon">
                <img src={'https://padel-if-module.web.app/assets/calendar.svg'} alt="" />
              </div>
              <div className="modal__content-value">
                {isPhoneModalOpen && selectedDate.format('dddd, DD MMMM')}
              </div>
            </div>
            <div className="modal__content-block">
              <div className="modal__content-icon">
                <img src={'https://padel-if-module.web.app/assets/clock.svg'} alt="" />
              </div>
              <div className="modal__content-value">
                {isPhoneModalOpen && `${startTime} - ${endTime}`}
              </div>
            </div>
            <div className="modal__content-block">
              <div className="modal__content-icon">
                <img src={'https://padel-if-module.web.app/assets/court.svg'} alt="" />
              </div>
              <div className="modal__content-value">
                {isPhoneModalOpen && `Корт №${court.courtName}`}
              </div>
            </div>
            <div className="modal__content-block">
              <div className="modal__content-icon">
                <img src={'https://padel-if-module.web.app/assets/banknote.svg'} alt="" />
              </div>
              <div className="modal__content-value">{isPhoneModalOpen && price}</div>
            </div>
          </div>
          <div className="content success-message"></div>
          <div className="content unsuccess-message"></div>
          <footer className="modal-footer">
            <div className="modal-footer__title">
              Вкажіть свій номер телефону для підтвердження бронювання:
            </div>
            <div className="modal-footer__number">
              <input
                className="modal-footer__number-input border-0 h-full w-full"
                placeholder="Iм'я"
                onChange={(e) => {
                  e.preventDefault();
                  setName(e.target.value);
                }}
                value={name}
              />
            </div>
            <div className="modal-footer__number">
              <InputMask
                className="modal-footer__number-input border-0 h-full w-full placeholder:text-black"
                type="tel"
                autoComplete="off"
                mask="+38 099 999 99 99"
                placeholder="+38 0"
                onChange={(e) => {
                  e.preventDefault();
                  setPhoneNumber(e.target.value.replace(/[^0-9]/g, ''));
                }}
                value={phoneNumber}
              />
            </div>
            <form
              style={{ display: 'flex', justifyContent: 'center' }}
              method="POST"
              target="_self"
              acceptCharset="utf-8"
              action="https://www.portmone.com.ua/gateway/">
              <input type="hidden" name="payee_id" value="136592" />
              <input type="hidden" name="shop_order_number" value={orderId} />
              <input type="hidden" name="bill_amount" value={price} />
              <input
                type="hidden"
                name="description"
                value={`Замовлення корту №${court?.courtName} на ${selectedDate.format(
                  'DD-MM-YYYY'
                )} з ${startTime} - ${endTime}`}
              />
              <input type="hidden" name="success_url" value={`${BASE_URL}/portmone/success`} />
              <input type="hidden" name="failure_url" value={`${BASE_URL}/portmone/error`} />
              <input type="hidden" name="lang" value="uk" />
              <input type="hidden" name="encoding" value="UTF-8" />
              <input type="hidden" name="attribute2" value={encodeURI(bookingData)} />
              <button
                className="payment-button"
                disabled={disabledPayment}
                style={disabledPayment ? { background: 'gray', opacity: '50%' } : {}}>
                <span className="payment-button-text">Сплатити</span>
              </button>
            </form>
          </footer>
        </div>
      </article>
    </div>
  );
};
